import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ClosingWizardActions = {
  closeCase: async ({ commit, state }, legalCaseId) => {
    let payload = {
      closing_reasons_ids: state.closingReasonsIds,
      closing_notes: state.closingNotes,
    }

    if (state.shouldSendNotification) {
      payload = {
        ...payload,
        closing_channels: state.closingChannels,
        closing_message: state.closingMessage,
        closing_recipient_id: state.closingRecipientId,
      }
    }

    return axiosRequest.
      patch(`/legal_cases/${legalCaseId}/close`, payload).
      then(({ data }) => {
        commit('setLegalCase', data.legal_case)
        return data
      }).
      catch(handleError)
  },

  getEmailNotificationEnabled: async ({ commit }) => {
    return axiosRequest.
      get('/legal_cases/email_notification_enabled').
      then(({ data }) => commit('setEmailNotificationEnabled', data.enabled))
  },
}

export const ClosingWizardGetters = {
  closingChannels: state => state.closingChannels,
  closingMessage: state => state.closingMessage,
  closingNotes: state => state.closingNotes,
  closingReasonsIds: state => state.closingReasonsIds,
  closingRecipientId: state => state.closingRecipientId,
  emailNotificationEnabled: state => state.emailNotificationEnabled,
  shouldSendNotification: state => state.shouldSendNotification,
}

export const ClosingWizardMutations = {
  resetClosingNotificationChannels: (state, _) => { state.closingChannels = null },
  setClosingNotes: (state, data) => { state.closingNotes = data },
  setClosingNotificationChannels: (state, data) => { state.closingChannels = data },
  setClosingNotificationMessage: (state, data) => { state.closingMessage = data },
  setClosingNotificationRecipientId: (state, data) => { state.closingRecipientId = data },
  setClosingReasonsIds: (state, data) => { state.closingReasonsIds = data },
  setEmailNotificationEnabled: (state, data) => { state.emailNotificationEnabled = (data === 'true') },
  setShouldSendNotification: (state, data) => { state.shouldSendNotification = data },
}

export const ClosingWizardState = {
  closingChannels: null,
  closingMessage: null,
  closingNotes: null,
  closingReasonsIds: [],
  closingRecipientId: null,
  emailNotificationEnabled: false,
  shouldSendNotification: false,
}
